import { createUseStyles } from "react-jss";
import { down } from "../../styles/breakpoints";
import {
  cardGrid,
  pageContentRoot,
  pageHeaderRow,
  pageShellRoot,
} from "../../styles/pageShell";

const useStyles = createUseStyles({
  contentMain: pageShellRoot,

  containerHeader: {
    ...pageHeaderRow,
    padding: "15px 0px",
  },

  vehiculeRoot: pageContentRoot,

  divApercu: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  /* Title on the left, filter on the right — stacked once there is no room
     for both on one line. */
  divApercuFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
    [down.sm]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },

  /* Was a fixed flex row, so the summary cards were squeezed to slivers
     before they ever wrapped. */
  divApercu2: cardGrid(200),

  divFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minWidth: "min(256px, 100%)",
    flexWrap: "wrap",
    textWrap: "nowrap",
    gap: "10px",
  },

  divIconArrow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    minWidth: 0,
    flex: "1 1 auto",
  },
});

export default useStyles;
